import { render, staticRenderFns } from "./ImportarEmpresas.vue?vue&type=template&id=fb2251e0&"
import script from "./ImportarEmpresas.vue?vue&type=script&lang=js&"
export * from "./ImportarEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports